import ChartTooltip from "components/Charts/ChartTooltip";

const PieTooltip = (values: any) => {
    const { datum } = values;

    return (
        <ChartTooltip
            label={`${datum.label}`}
            value={datum.formattedValue}
            color={datum.color}
        />
    )
}

export default PieTooltip